'use strict';

class NavbarController {
  constructor($location, NavbarSvc) {
    this.isCollapsed = true;
    this.navbar = Object;
    this.isOauth = $location.path().indexOf('oauth') >= 0;
    var that = this;
    var updateNavbar = function(updatedNavbar) {
      that.navbar = updatedNavbar;
    };
    NavbarSvc.registerObserverCallback(updateNavbar);
  }
}

NavbarController.$inject = ['$location', 'NavbarSvc'];
export default NavbarController;
